<template>
  <div>
    <el-scrollbar max-height="80vh">
      <el-form
        ref="createFormRef"
        :style="formPageStyle"
        label-position="top"
        :model="globalForm"
        :rules="globalRules"
        label-width="120px"
      >
        <View :key="cnpKey" :widget-data-list="widgetData.list"></View>
      </el-form>
    </el-scrollbar>
    <div v-if="widgetData?.list?.length && formButtonVisible" class="form-page-submit-container">
      <template v-if="isStepForm">
        <el-button type="primary" class="btn" :disabled="step === 0" @click="prevStep">
          {{ $t('global.preStep') }}
        </el-button>
        <el-button v-if="step < stepMax" type="primary" class="btn" @click="nextStep">
          {{ $t('global.nextStep') }}
        </el-button>
        <el-button
          v-else
          type="primary"
          class="btn"
          :loading="formSubmitLoading"
          @click="onFormSubmit"
        >
          {{ $t('global.confirm') }}
        </el-button>
      </template>
      <el-button
        v-else
        type="primary"
        class="btn"
        :loading="formSubmitLoading"
        @click="onFormSubmit"
      >
        {{ $t('global.confirm') }}
      </el-button>
      <el-button class="btn cancle" @click="closeDialog"> {{ $t('global.cancel') }} </el-button>
    </div>
    <!-- <DialogPage v-model:dialog-visible="dialogVisible" :page-id="pageId"></DialogPage>
    <MultipleJump></MultipleJump> -->
  </div>
</template>
<script lang="ts">
  export default {
    name: 'NormalFormPage'
  }
</script>
<script setup lang="ts">
  import { ref, watch, computed, onMounted, onBeforeUnmount } from 'vue'
  import { getApiMenu, invokeApiMenu, queryLFMenuItemReq, invokeLogicFlow } from '@haohan/clw-api'
  import { useProject, useEvent, useGlobalStore } from '@haohan/clw-store'
  import { addDataAssemble, editDataAssemble } from '@haohan/clw-api'
  import { ElMessage } from 'element-plus'
  import {
    getKey,
    getFormPayloadByWidgetList,
    transformInvokePayloadToFormDataFromKeys,
    emitter,
    removeEmpty,
    handleApiAfterFun,
    transformLogicFlowParams,
    emitWithCallbacks,
    handleApiResponseData,
    getCompChildren,
    evalFn,
    showTemplatePreviewTip
  } from '@haohan/clw-utils'
  import View from '../View.vue'
  import { has } from 'lodash-es'
  import { useMessage } from '@haohan/clw-hooks'
  import { useI18n } from 'vue-i18n'

  // 校验流程：组件自身校验 -> 步骤条校验 -> 表单整体校验
  // 各校验有矛盾时，需使用者核实

  interface WidgetDataInfo {
    list: Widget[]
  }
  const props = defineProps<{ widgetData: WidgetDataInfo; page?: any; isDialogPage?: boolean }>()
  const emit = defineEmits<{
    (e: 'closeDialog', value: boolean): void
  }>()
  const projectStore = useProject()
  const eventStore = useEvent()
  // 使用该方法强制重新渲染组件
  const cnpKey = ref(getKey())
  const { t } = useI18n()

  const currentPage = computed(() => (props.page ? props.page : projectStore?.currentPage))
  // 表单页, padding
  const formPageStyle = computed(() => {
    const styleProp = currentPage.value.variables?.formAttribute?.styleProp
    if (styleProp) {
      return Object.keys(styleProp)
        .map((padding) => {
          return `${padding}:${styleProp[padding]}px`
        })
        .join(';')
    }
    return {}
  })

  // 表单和 rules
  const globalForm = computed(() => projectStore.currentForm)
  const globalRules = computed(() => projectStore.currentFormRulesParsed)
  const comps = computed(() => props.widgetData.list)
  const isStepForm = computed(() => {
    return comps.value.length === 1 && comps.value[0].type === 'FormStep'
  })
  const stepComp = computed(() => (isStepForm.value ? comps.value[0] : null))
  const stepMax = computed(() => stepComp.value?.dataProp?.defaultData.length - 1 || 0)
  const step = ref(0)
  const stepCompData = computed(() => {
    return stepComp.value?.dataProp?.defaultData[step.value].list
  })
  const stepValidFn = computed(() => stepComp.value?.prop?.validFn || '')
  const formValidFn = computed(() => currentPage.value.variables?.formAttribute?.validFn || '')

  const currentForm = computed(() => {
    // if (!stepComp.value) {
    //   return {}
    // }
    const allChilds = kpMapping(getAllChild([props.widgetData]))
    return mergeFrom(globalForm.value, allChilds)
  })

  function prevStep() {
    step.value -= 1
    projectStore.upCurrentFormStep(step.value)
    // const compKeys = getAllKeyValues(stepCompData.value)
    // // console.log(compKeys)
    // createFormRef.value?.validateField(compKeys, (valid: any) => {
    //   if (valid) {
    //     // 步骤条自定义校验
    //     if (stepValidFn.value) {
    //       const fn = evalFn(stepValidFn.value)
    //       const isPass = fn(currentForm.value, step.value + 1)
    //       if (isPass === true) {
    //         step.value -= 1
    //         projectStore.upCurrentFormStep(step.value)
    //       } else {
    //         ElMessage.warning(isPass || '步骤条自定义校验未通过')
    //       }
    //     } else {
    //       step.value -= 1
    //       projectStore.upCurrentFormStep(step.value)
    //     }
    //   }
    // })
  }
  function nextStep() {
    const compKeys = getAllKeyValues(stepCompData.value)
    // console.log(compKeys)
    createFormRef.value?.validateField(compKeys, (valid: any) => {
      if (valid) {
        // 步骤条自定义校验
        if (stepValidFn.value) {
          const fn = evalFn(stepValidFn.value)
          const isPass = fn(currentForm.value, step.value + 1)
          if (isPass === true) {
            step.value += 1
            projectStore.upCurrentFormStep(step.value)
          } else {
            ElMessage.warning(isPass || t('component.form.stepValidateTip'))
          }
        } else {
          step.value += 1
          projectStore.upCurrentFormStep(step.value)
        }
      }
    })
  }
  /**
   * 获取嵌套数组中所有元素的键值
   */
  function getAllKeyValues(list: any[], key = 'key') {
    const result: string[] = []
    for (const item of list) {
      if ('children' in item && Array.isArray(item.children)) {
        for (const childGroup of item.children) {
          if ('list' in childGroup && Array.isArray(childGroup.list)) {
            result.push(...getAllKeyValues(childGroup.list, key))
          }
        }
      } else if (key in item) {
        result.push(item[key])
      }
    }
    return result
  }
  function getAllChild(comps: any[]) {
    const result: Widget[] = []
    for (const c1 of comps) {
      for (const c2 of c1.list) {
        result.push(c2)
        const children = getCompChildren(c2)
        result.push(...getAllChild(children))
      }
    }
    return result
  }
  function kpMapping(list: Widget[]) {
    const mapping: Record<string, string> = {}
    list.forEach((item) => {
      const key = item.key
      const propKey = item.formProp?.tableColumn
      if (propKey) {
        mapping[key!] = propKey
      }
    })
    return mapping
  }
  function mergeFrom(kform: any, kpform: any) {
    const result: any = {}
    for (const key in kform) {
      if (Object.prototype.hasOwnProperty.call(kform, key)) {
        result[kpform[key]] = kform[key]
      }
    }
    return result
  }

  watch(
    () => props.widgetData.list,
    (val) => {
      if (projectStore.isFormPage) {
        // 重置表单和 rules
        projectStore.resetCurrentFormAndRules()
        // 更新表单
        projectStore.updateCurrentFormByWidgetList(props.widgetData.list)
        // 更新 rules
        projectStore.updateCurrentFormRulesByWidgetList(props.widgetData.list)
      }
    },
    { deep: true }
  )

  const formSubmitLoading = ref(false)
  const createFormRef = ref()
  const getFormPayload = (list: any, form: any) => {
    const { filterNullValues, filterExtraValues } = currentPage.value?.variables?.formAttribute
    let payload = getFormPayloadByWidgetList(list, form, filterNullValues)
    if (!filterExtraValues) {
      // 从表格行点击, 编辑时带有id等其他参数, 虽然不在表单修改范围, 但是不可缺少
      const data = eventStore.formParamsFromTableCustomAction[currentPage.value.id] as any
      if (data?.params) {
        const params = data.params
        if (params && Object.keys(params)) {
          payload = { ...params, ...payload }
        }
      }
    }
    // 只有为 true 才过滤 null 和 ''
    if (filterNullValues) {
      payload = removeEmpty(payload)
    }
    return {
      data: payload
    }

    // const { filterNullValues } = currentPage.value.variables?.formAttribute
    // return {
    //   data: getFormPayloadByWidgetList(list, form, filterNullValues)
    // }
  }

  /**
   * 表单 - 未配数据源, 隐藏提交按钮
   */
  const formButtonVisible = computed(() => {
    const tableId =
      currentPage.value.variables?.formAttribute?.tableId ||
      currentPage.value.variables?.formAttribute?.apiUrl
    return Boolean(tableId)
  })

  /**
   * 表单 - 数据集方式
   */
  const datasourceFormSubmit = () => {
    // 默认为数据集, 不存在则为自定义 API
    const tableId =
      currentPage.value.variables?.formAttribute?.tableId ||
      currentPage.value.variables?.formAttribute?.apiUrl
    // 数据表, 拼接表的 id: 'dataSourceId;schema;name'
    const isDataTable = tableId.includes(';')
    const projectId = projectStore.currentProject.id
    const payload = getFormPayload(props.widgetData.list, globalForm.value)
    if (!tableId) {
      return ElMessage.warning(t('global.missDataSetAttr'))
    }
    if (!isDataTable) {
      return ElMessage.warning(t('global.isNotOriginalTable'))
    }
    formSubmitLoading.value = true
    // 取主键
    const pId = eventStore.formParamsFromTableCustomAction[`${currentPage.value.id}_primaryKey`]
    let doDataAssemble = addDataAssemble
    if (payload.data[pId] && payload.data[pId] !== '') {
      doDataAssemble = editDataAssemble
      // 增加IDS参数
      payload.ids = {
        [pId]: payload.data[pId]
      }
      // 剔除主键值，避免报错
      delete payload.data[pId]
    }
    doDataAssemble(projectId, tableId, payload)
      .then(() => {
        ElMessage.success(t('global.operationSuccess'))
        // 关闭弹窗
        closeDialog()

        // 刷新表格
        onEmitCustomActionCallback()
      })
      .finally(() => {
        formSubmitLoading.value = false
      })
  }
  /**
   * 表单 - 自定义 API
   */
  const customApiFormSubmit = async () => {
    const { tableId } = currentPage.value.variables?.formAttribute || {}
    const projectId = projectStore.currentProject?.id
    const payload = getFormPayload(props.widgetData.list, globalForm.value)

    if (!tableId) {
      return ElMessage.warning(t('global.missDataSetAttr'))
    }

    formSubmitLoading.value = true

    // 详情
    const { data } = await getApiMenu(projectId, tableId)
    // 提交
    invokeApiMenu(
      projectId,
      tableId,
      transformInvokePayloadToFormDataFromKeys(data?.keysDefine.def, payload.data)
    )
      .then((res: any) => {
        // res = handleApiAfterFun(data.postPosition, res)
        const _data = handleApiResponseData(handleApiAfterFun(data.postPosition, res))
        if (
          _data.status === 200 &&
          has(_data, 'data') &&
          has(_data.data, 'status') &&
          _data.data.status !== 200 &&
          _data.data.status !== 0
        ) {
          const message = _data.data.message || _data.data.tag || t('global.dataSubmissionFailed')
          ElMessage.error(message)
          return false
        }
        // 后端可能不返回内容, status 为 200 也表示成功, 即前端 {data: ''}
        if (_data.status === 0 || _data.status === 200 || (!_data.status && !_data.data)) {
          ElMessage.success(t('global.confirmSuccess'))
          // 关闭弹窗
          closeDialog()

          // 刷新表格
          onEmitCustomActionCallback()
        } else {
          const message = _data.message || _data.tag || t('global.dataSubmissionFailed')
          ElMessage.error(message)
        }
      })
      // .catch((error: any) => {
      //   // ElMessage.error('数据提交失败，请检查提交数据是否正确')
      //   if (error?.response?.data || error?.response?.data.message) {
      //     useMessage(error.response.data)
      //   }
      // })
      .finally(() => {
        formSubmitLoading.value = false
      })
  }

  const customLogicFlowSubmit = async () => {
    const { tableId } = currentPage.value.variables?.formAttribute || {}
    const projectId = projectStore.currentProject?.id
    const payload = getFormPayload(props.widgetData.list, globalForm.value)

    if (!tableId) {
      return ElMessage.warning(t('global.misLogicFlowAttr'))
    }

    formSubmitLoading.value = true

    // 获得逻辑流详细信息
    const { data } = await queryLFMenuItemReq(projectId, tableId)

    // 处理逻辑流数据
    invokeLogicFlow(projectId, tableId, transformLogicFlowParams(data.parameters, payload.data))
      .then((res: any) => {
        if (
          res?.status === 200 &&
          has(res, 'data') &&
          has(res.data, 'status') &&
          res.data.status !== 200 &&
          res.data.status !== 0
        ) {
          const message = res?.data.message || res?.data.tag || t('global.dataSubmissionFailed')
          ElMessage.error(message)
          return false
        }
        // 后端可能不返回内容, status 为 200 也表示成功, 即前端 {data: ''}
        if (res?.status === 0 || res?.status === 200 || (!res?.status && !res.data)) {
          ElMessage.success(t('global.confirmSuccess'))
          // 关闭弹窗
          closeDialog()

          // 刷新表格
          onEmitCustomActionCallback()
        } else {
          const message = res?.message || res?.tag || t('global.dataSubmissionFailed')
          ElMessage.error(message)
        }
      })
      .catch((error: any) => {
        if (error?.response?.data || error?.response?.data.message) {
          useMessage(error.response.data)
        }
      })
      .finally(() => {
        formSubmitLoading.value = false
      })
  }
  /**
   * 表格自定义操作触发的表格刷新操作
   */
  const onEmitCustomActionCallback = () => {
    // 从表格行点击, 编辑时带有id等其他参数, 虽然不在表单修改范围, 但是不可缺少
    const data = eventStore.formParamsFromTableCustomAction[currentPage.value.id] as any
    if (data?.emitterKey) {
      emitter.emit(data?.emitterKey)
    }
  }

  enum FORM_DATA_TYPE {
    datasource = 'datasource',
    api = 'api',
    logicFlowSource = 'LogicFlowSource'
  }
  /**
   * 表单页提交
   */
  const onFormSubmit = () => {
    if (showTemplatePreviewTip()) {
      return false
    }
    createFormRef?.value?.validate(async (valid: boolean) => {
      if (!valid) {
        ElMessage.warning(t('global.validationFailedTip'))
        return false
      }
      // 最后一步的步骤条自定义校验
      if (stepValidFn.value) {
        const fn = evalFn(stepValidFn.value)
        const isPass = fn(currentForm.value, step.value + 1)
        if (!isPass || typeof isPass === 'string') {
          ElMessage.warning(isPass || t('component.form.stepValidateTip'))
          return
        }
      }
      // 表单整体自定义校验
      if (formValidFn.value) {
        const fn = evalFn(formValidFn.value)
        const isPass = fn(currentForm.value)
        if (!isPass || typeof isPass === 'string') {
          ElMessage.warning(isPass || t('component.form.formValidateTip'))
          return
        }
      }
      const formAttribute = currentPage.value.variables?.formAttribute
      if (!formAttribute) {
        return ElMessage.warning(t('global.missFormAttr'))
      }
      // const result = await emitAsync('form-submit-check')
      const result = await emitWithCallbacks('form-submit-check', {})
      // console.log('form-submit-check', result)
      // const hasFail = result.some((item: any) => item.success === false)
      // if (result.length > 0 && hasFail) {
      //   ElMessage.warning('文件上传存在失败项，请检查')
      // }
      const { dataType } = formAttribute
      // 表单 - 数据集方式 | 自定API地址
      if (dataType === FORM_DATA_TYPE.datasource) {
        datasourceFormSubmit()
      } else if (dataType === FORM_DATA_TYPE.api) {
        customApiFormSubmit()
      } else {
        customLogicFlowSubmit()
      }
      // dataType === FORM_DATA_TYPE.datasource ? datasourceFormSubmit() : customApiFormSubmit()
    })
  }

  const closeDialog = () => {
    step.value = 0
    projectStore.upCurrentFormStep(step.value)
    if (props.isDialogPage) {
      emit('closeDialog', false)
    }
  }

  function handleEvent({ data, callback }: any) {
    // console.log(data)
    let compKeys: any[] = []
    const steps: number[] = []
    if (data.from < data.to) {
      for (let ix = data.from; ix < data.to; ix++) {
        compKeys = compKeys.concat(getAllKeyValues(stepComp.value?.dataProp?.defaultData[ix].list))
        steps.push(ix)
      }
    }
    // else {
    //   compKeys = getAllKeyValues(stepComp.value?.dataProp?.defaultData[data.from].list)
    //   steps.push(data.from)
    // }
    createFormRef.value?.validateField(compKeys, (valid: any) => {
      if (valid) {
        if (stepValidFn.value) {
          const fn = evalFn(stepValidFn.value)
          for (const step of steps) {
            const isPass = fn(currentForm.value, step + 1)
            if (!isPass || typeof isPass === 'string') {
              ElMessage.warning(isPass || t('component.form.stepValidateTip'))
              return
            }
          }
        }
        step.value = data.to
        projectStore.upCurrentFormStep(step.value)
        // callback({ success: isPass, message: isPass ? '通过' : '未通过' })
      }
    })
  }

  onMounted(() => {
    emitter.on('form-step-check', handleEvent)
  })
  onBeforeUnmount(() => {
    emitter.off('form-step-check', handleEvent)
  })
</script>
<style lang="scss" scoped>
  .form-page-submit-container {
    margin-top: 32px;
    text-align: center;
    .btn {
      width: 100px;
    }
    .el-button {
      & + .el-button {
        margin-left: 80px;
      }
    }
    // .cancle {
    //   margin-left: 80px;
    // }
  }
  // .show {
  //   max-height: calc(100vh - 300px);
  // }
</style>
